import { RegistrationForm } from 'components';

export const RegistrationPage = () => {
  return <RegistrationForm />;
};

export default RegistrationPage;
